// @flow

import { observer } from "mobx-react";
import React from "react";

import UserThumbnail from "app/components/UserThumbnail/UserThumbnail";

import "./VideoAuthor.scss";

type Props = {
    name?: string,
    image?: string
};

@observer
export default class VideoAuthor extends React.Component<Props> {

    render() {
        const name = this.props.name || "Your name here";
        const image = this.props.image;

        return (
            <div className="VideoAuthor clearfix">
                <UserThumbnail name={name} image={image} />
                <div className="VideoAuthor__name">{name}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoAuthor/VideoAuthor.js